import React from 'react';
import styled, { css } from 'styled-components';
import { color, gutter } from '../../styles/mixins';
import { label12 } from '../../styles/typography';

export enum StatusVariant {
  Info = 'info',
  Success = 'success',
  Danger = 'danger',
  Warning = 'warning',
}

const Host = styled.div`
  display: flex;
  align-items: center;
`;
const Dot = styled.div<{ variant: StatusVariant }>`
  margin-right: ${gutter(1)};
  height: ${gutter(1)};
  width: ${gutter(1)};
  border-radius: ${gutter(1)};

  /* Background */
  ${(props) => {
    switch (props.variant) {
      case StatusVariant.Success:
        return css`
          background-color: ${color('green60')};
        `;
      case StatusVariant.Danger:
        return css`
          background-color: ${color('red60')};
        `;
      case StatusVariant.Warning:
        return css`
          background-color: ${color('orange20')};
        `;
      case StatusVariant.Info:
        return css`
          background-color: ${color('blue10')};
        `;
    }
  }}
`;
const Text = styled.div`
  ${label12};
`;

interface StatusProps {
  children: React.ReactNode;
  variant?: StatusVariant;
}

export const Status = ({
  children,
  variant = StatusVariant.Success,
}: StatusProps) => {
  return (
    <Host>
      <Dot variant={variant} />
      <Text>{children}</Text>
    </Host>
  );
};
